import React, { useState } from 'react'
import { NoticeLoading, ContentAdd, ContentCheck } from '@fs/zion-icon'
import { LabelTooltip } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import CardActionButton from './CardActionButton'

const actionButtonWrapperCss = css`
  position: absolute;
  bottom: 16px;
  right: 16px;
`

export default function CardAddRemoveButton({ isInPlaylist, onClick, absolutePositioned, ...props }) {
  const [t] = useTranslation()
  const [pending, setPending] = useState(false)

  let CardIcon = ContentAdd

  if (pending) {
    CardIcon = NoticeLoading
  } else if (isInPlaylist) {
    CardIcon = ContentCheck
  }

  const handleClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    const possiblePromise = onClick(e)
    if (possiblePromise instanceof Promise) {
      setPending(true)
      possiblePromise.then(() => {
        setPending(false)
      })
    }
  }

  const label = isInPlaylist
    ? t('series.remove-from-playlist.action', 'Remove from playlist')
    : t('series.add-to-playlist.action', 'Add to Playlist')

  return (
    <div css={actionButtonWrapperCss} style={{ color: 'white', position: absolutePositioned ? 'absolute' : 'unset' }}>
      <LabelTooltip
        label={label}
        placement="left"
        target={
          <div style={{ marginLeft: 8 }}>
            <CardActionButton
              CardIcon={CardIcon}
              onClick={handleClick}
              iconColor={!pending && isInPlaylist ? 'black' : 'white'}
              backgroundColor={!pending && isInPlaylist ? '#fc4e6d' : undefined}
              aria-label={label}
              {...props}
            />
          </div>
        }
      />
    </div>
  )
}
